import IconTiktok from "@icons/dark/tiktok.svg?react";
import type { LinkedAccountPlatform } from "@store/linkedAccountSlice";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";

const PLATFORM_LABELS: Record<LinkedAccountPlatform, string> = {
  TIKTOK: "TikTok",
};

interface PlatformLabelProps {
  platform: LinkedAccountPlatform;
  className?: string;
}

export const PlatformLabel = ({ platform, className }: PlatformLabelProps) => {
  return (
    <div className={twMerge("flex shrink-0 gap-[6px]", className)}>
      <div className="flex size-[24px] shrink-0 items-center justify-center overflow-hidden rounded-[7px] bg-black">
        <IconTiktok width={20} height={20} />
      </div>
      <span className="text-[16px] font-medium leading-[22px] text-kds-fg">
        <Trans>{PLATFORM_LABELS[platform] ?? platform}</Trans>
      </span>
    </div>
  );
};
